import React, { Component } from 'react';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".styles_selectBox__3T9pf{\n    display: flex;\n    width: 90%;\n    padding: 20px;   \n    flex-direction: column;\n    order: 0;\n}\n\n.styles_selectBox__3T9pf .styles_optionsContainer__Ic7l9{\n    background-color: #2f3640;\n    color: #fff;\n    width: 100%;\n    transition: all 0.4s;\n    border-radius: 8px;\n    overflow: hidden;\n    order: 1;\n    max-height: 100px; \n    opacity: 1;\n    overflow-y: scroll;\n}\n\n.styles_selectedBox__3ipXg{\n    background-color: #2f3640;\n    border-radius: 8px;\n    margin-bottom: 8px;\n    position: relative;\n    color: #fff;\n}\n.styles_selectedBox__3ipXg::after{\n    content: \"v\";\n    z-index: 99999;\n    /* background-image: url(\"./assets/arrow-down.svg\"); */\n    background-size: contain;\n    background-repeat: no-repeat;\n  \n    position: absolute;\n    /* height: 100%; */\n    font-size: 24px;\n    left: 90%;\n    top: 5px;\n    transition: all 0.4s;\n}\n\n.styles_optionsContainer__Ic7l9{\n\n}\n\n.styles_selectBox__3T9pf .styles_optionsContainer__Ic7l9 {\n    max-height: 240px;\n    opacity: 1;\n    overflow-y: scroll;\n}\n\n.styles_selectBox__3T9pf .styles_optionsContainer__Ic7l9 + .styles_selectedBox__3ipXg::after{\n    transform: rotateX(180deg);\n    top: 5px;\n}\n\n.styles_selectBox__3T9pf .styles_optionsContainer__Ic7l9::-webkit-scrollbar {\n    width: 8px;\n    background-color: #0d141f;\n    border-radius: 0 8px 8px 0;\n}\n\n.styles_selectBox__3T9pf .styles_optionsContainer__Ic7l9::-webkit-scrollbar-thumb {\n    background-color: #525861;\n    border-radius: 0 8px 8px 0;\n}\n\n.styles_selectBox__3T9pf .styles_option__2EOeg,\n.styles_selectedBox__3ipXg{\n    padding: 12px 24px;\n    cursor: pointer;\n}\n\n.styles_selectBox__3T9pf .styles_option__2EOeg:hover{\n    background-color: #414b57;\n}\n\n.styles_selectBox__3T9pf label{\n    cursor: pointer;\n}\n\n.styles_selectBox__3T9pf .styles_option__2EOeg .styles_radio__1HOdr{\n    display: none;\n}";
var styles = { "selectBox": "styles_selectBox__3T9pf", "optionsContainer": "styles_optionsContainer__Ic7l9", "selectedBox": "styles_selectedBox__3ipXg", "option": "styles_option__2EOeg", "radio": "styles_radio__1HOdr" };
styleInject(css);

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#f5f6fa",
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
});

var SelectTag = function SelectTag(_ref2) {
  var classNameForSelectTag = _ref2.classNameForSelectTag,
      showOptions = _ref2.showOptions,
      heading = _ref2.heading,
      visibleData = _ref2.visibleData,
      setItemSelect = _ref2.setItemSelect,
      handleChange = _ref2.handleChange,
      handleSelectClick = _ref2.handleSelectClick,
      data = _ref2.data;
  return React.createElement(
    "div",
    {
      className: styles.selectBox + " " + classNameForSelectTag,
      onClick: function onClick() {
        return handleSelectClick();
      }
    },
    showOptions && React.createElement(
      "div",
      { className: styles.optionsContainer, id: "optionContainer" },
      data && data.map(function (item, index) {
        return React.createElement(
          "div",
          {
            className: styles.option,
            onClick: function onClick() {
              return setItemSelect(item.value);
            }
          },
          React.createElement("input", {
            type: "radio",
            className: styles.radio,
            id: item.value,
            name: item.value
          }),
          React.createElement(
            "label",
            { "for": item.value },
            item.displayName
          )
        );
      })
    ),
    React.createElement(
      "div",
      { className: styles.selectedBox },
      visibleData ? visibleData : heading
    )
  );
};

var css$1 = ".styles_inputModal__2gpiN{\n    height: 0;\n    height: 100%;\n    width: 100%;\n    background-color: #2f36403a;\n    z-index: 1;\n    position: absolute;\n    bottom: 0px;\n    left: 0;\n    flex-direction: column;\n    display: flex;\n    justify-content: flex-end;\n    align-items: flex-end;\n    overflow: hidden; /* Hide scrollbars */\n}\n\n.styles_modalCloseButton__nrj1G{\n    /* width: calc(100% - 20px); */\n    /* margin: 5px 0 0 0; */\n    width: 100%;\n    height: 40px;\n    transition: all 2s;\n    border-radius: 10px;\n    border-width: 0px;\n    font-size: 20px;\n    animation: styles_grow__fN-tq 0.2s 0s 1;\n}\n\n@keyframes styles_grow__fN-tq {\n    0%{\n        height:0px\n    };\n    100%{\n        height:100px\n\n    }\n}\n\n.styles_optionsContiner__1xg-I{\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    list-style-type: none;\n    font-size: 20px;\n    height: 140px;\n    border-radius: 10px;\n    overflow: hidden;\n    overflow: scroll;\n    margin-bottom:-10px\n}\n\n::-webkit-scrollbar {\n    width: 0;  /* Remove scrollbar space */\n    background: transparent;  /* Optional: just make scrollbar invisible */\n}\n/* Optional: show position indicator in red */\n::-webkit-scrollbar-thumb {\n    background: transparent;\n}\n.styles_selectedElement__1AOqw{\n    position: static;\n    top: 25px;\n    left: 0;\n    color: #000;\n    width: 100px;\n    text-align: center;\n    font-size: 1.5em;\n    background-image: linear-gradient(rgba(238, 238, 238, 0.699),#ddd,#ddd,#ddd,rgba(238, 238, 238, 0.514));\n    border: #aaa solid 0px;\n}\n\n.styles_listOfOptions__2Pv3j{\n    display: flex;\n    position: relative;\n    flex-direction: column;\n    width: 100%;\n    border-radius: 10px;\n    overflow: hidden;\n    justify-content: center;\n}\n.styles_listOfOptions__2Pv3j, a{\n    text-align: center;\n    background-color: #fff;\n    border: 1px solid #eee;\n    color: black;\n    padding: 5px 0;\n    /* border-radius: 10px; */\n    width: 100%;\n    font-weight: bold;\n    overflow: hidden; /* Hide scrollbars */\n    text-decoration: none;\n}\n\n\n.styles_listOfOptions__2Pv3j ul:nth-child(1){\n    /* margin-top: 25px; */\n}\n.styles_listOfOptions__2Pv3j ul{\n    font-size: 1.1em;\n    opacity: 0.5;\n    transform: rotateX(50deg);\n}\n.styles_listOfOptions__2Pv3j ul{\n    font-size: 1.1em;\n    opacity: 0.3;\n    transform: rotateX(50deg);\n}\n.styles_listOfOptions__2Pv3j ul:last-child{\n    margin-bottom: 50px;\n}\n\n";
var styles$1 = { "inputModal": "styles_inputModal__2gpiN", "modalCloseButton": "styles_modalCloseButton__nrj1G", "grow": "styles_grow__fN-tq", "optionsContiner": "styles_optionsContiner__1xg-I", "selectedElement": "styles_selectedElement__1AOqw", "listOfOptions": "styles_listOfOptions__2Pv3j" };
styleInject(css$1);

var SimpleModal = function SimpleModal(_ref) {
  var visibleData = _ref.visibleData,
      heading = _ref.heading,
      classNameForModal = _ref.classNameForModal,
      handleItemClick = _ref.handleItemClick,
      setModelClose = _ref.setModelClose,
      data = _ref.data;
  return React.createElement(
    "div",
    { className: classNameForModal },
    React.createElement(SelectTag, { data: data, heading: heading }),
    React.createElement(
      "div",
      null,
      React.createElement(
        "div",
        { className: styles$1.inputModal + "  " + styles$1.outterContiner },
        React.createElement(
          "div",
          { className: styles$1.optionsContiner, id: "modal" },
          React.createElement(
            "span",
            { className: styles$1.listOfOptions },
            data && data.map(function (item, index) {
              return React.createElement(
                "a",
                {
                  className: "elemets",
                  href: "#",
                  value: item.value,
                  onClick: handleItemClick
                },
                item.displayName
              );
            })
          )
        ),
        React.createElement(
          "button",
          {
            onClick: function onClick() {
              return setModelClose(false);
            },
            className: "" + styles$1.modalCloseButton
          },
          "cancel"
        )
      )
    )
  );
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// import PropTypes from 'prop-types'

var Scroller = function (_Component) {
  inherits(Scroller, _Component);

  function Scroller(props) {
    classCallCheck(this, Scroller);

    var _this = possibleConstructorReturn(this, (Scroller.__proto__ || Object.getPrototypeOf(Scroller)).call(this, props));

    _this.state = {
      isMovingUp: false,
      isMoving: false,
      scrollPos: 0,
      scrollTolrence: 0,
      totalData: [1, 2, 3, 4, 5, 6],
      centerElementPossition: 0,
      visibleData: null,
      centerData: 20,
      closeModal: true,
      isMobileView: false,
      showOptions: false
    };

    _this.handleItemClick = _this.handleItemClick.bind(_this);
    _this.setModelClose = _this.setModelClose.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.setItemSelect = _this.setItemSelect.bind(_this);
    _this.handleSelectClick = _this.handleSelectClick.bind(_this);
    return _this;
  }

  createClass(Scroller, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var mobileViewThreshold = this.props.mobileViewThreshold;


      var isMobile = window.innerWidth < mobileViewThreshold;
      this.setState({
        isMobileView: isMobile
      });
    }
  }, {
    key: "handleSelectClick",
    value: function handleSelectClick() {
      var _state = _extends$1({}, this.state),
          isMobileView = _state.isMobileView,
          showOptions = _state.showOptions;

      var optionContainer = document.getElementById("optionsContainer");
      if (showOptions) {
        return;
      }
      console.log("optionContainer", optionContainer);
      this.setState({
        closeModal: !isMobileView
      });
      if (!isMobileView) {
        this.setState({
          showOptions: true
        });
      } else {
        this.setState({
          showOptions: false
        });
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      this.setState({
        visibleData: e.target.value,
        closeModal: true
      });
    }
  }, {
    key: "setItemSelect",
    value: function setItemSelect(item) {
      var onSelectedDataChange = this.props.onSelectedDataChange;


      this.setState({
        visibleData: item,
        closeModal: true,
        showOptions: false
      });
      onSelectedDataChange(item);
    }
  }, {
    key: "handleItemClick",
    value: function handleItemClick(e) {
      var onSelectedDataChange = this.props.onSelectedDataChange;

      var selectedValue = e.target.getAttribute("value");

      onSelectedDataChange(selectedValue);
      this.setState({
        visibleData: selectedValue,
        closeModal: true
      });
    }
  }, {
    key: "setModelClose",
    value: function setModelClose(status) {
      this.setState({
        closeModal: status
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = _extends$1({}, this.props),
          data = _props.data,
          heading = _props.heading,
          classNameForModal = _props.classNameForModal,
          classNameForSelectTag = _props.classNameForSelectTag;

      var _state2 = _extends$1({}, this.state),
          closeModal = _state2.closeModal,
          visibleData = _state2.visibleData,
          isMobile = _state2.isMobile,
          showOptions = _state2.showOptions;

      console.log(this.state);
      if (closeModal) {
        return React.createElement(SelectTag, {
          classNameForSelectTag: classNameForSelectTag,
          heading: heading,
          showOptions: showOptions,
          visibleData: visibleData,
          setItemSelect: this.setItemSelect,
          handleChange: this.handleChange,
          handleSelectClick: this.handleSelectClick,
          data: data
        });
      }

      return React.createElement(SimpleModal, {
        heading: heading,
        classNameForModal: classNameForModal,
        visibleData: visibleData,
        handleItemClick: this.handleItemClick,
        setModelClose: this.setModelClose,
        data: data
      });
    }
  }]);
  return Scroller;
}(Component);

function ExampleComponent(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? [] : _ref$data,
      _ref$mobileViewThresh = _ref.mobileViewThreshold,
      mobileViewThreshold = _ref$mobileViewThresh === undefined ? 450 : _ref$mobileViewThresh,
      _ref$heading = _ref.heading,
      heading = _ref$heading === undefined ? "Choose" : _ref$heading,
      _ref$classNameForModa = _ref.classNameForModal,
      classNameForModal = _ref$classNameForModa === undefined ? "" : _ref$classNameForModa,
      _ref$classNameForSele = _ref.classNameForSelectTag,
      classNameForSelectTag = _ref$classNameForSele === undefined ? "" : _ref$classNameForSele,
      _ref$onSelectedDataCh = _ref.onSelectedDataChange,
      _onSelectedDataChange = _ref$onSelectedDataCh === undefined ? function () {
    return undefined;
  } : _ref$onSelectedDataCh;

  return React.createElement(Scroller, {
    classNameForModal: classNameForModal,
    classNameForSelectTag: classNameForSelectTag,
    heading: heading,
    data: data,
    mobileViewThreshold: mobileViewThreshold,
    onSelectedDataChange: function onSelectedDataChange(data) {
      return _onSelectedDataChange(data);
    } });
}

export default ExampleComponent;
//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ../dist/index.es.js
// module id = 18
// module chunks = 0